$(function() {
	// @codekit-prepend 'js/functions.js'
	// @codekit-prepend 'js/donate.js'
	// @codekit-prepend 'js/chametz.js'
	// @codekit-prepend 'js/event.js'
	
});